import { render, staticRenderFns } from "./TransferHelp.vue?vue&type=template&id=6e1a05ad"
import script from "./TransferHelp.vue?vue&type=script&lang=js"
export * from "./TransferHelp.vue?vue&type=script&lang=js"
import style0 from "./TransferHelp.vue?vue&type=style&index=0&id=6e1a05ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports